<template>
  <v-card
    class="pa-8"
  >
    <div class="header">
      <div
        class="d-flex align-center"
        style="gap: 10px; margin-bottom: 10px;"
      >
        <v-icon
          size="20"
          color="#E7E3FC"
        >
          {{ icons.mdiLinkVariant }}
        </v-icon>
        <h3 class="title">
          Vincular Solicitações
        </h3>
      </div>
      <span style="font-size: 14px; font-weight: 500; color: #E7E3FC;">Selecione as solicitações que deseja vincular como filhas</span>
      <v-btn
        icon
        class="close-btn"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="content pt-7">
      <div
        class="d-flex flex-column"
        style="gap: 16px;"
      >
        <span style="font-weight: 500; font-size: 14px; color: #E7E3FC;">Solicitação pai:</span>
        <article class="parent-card">
          <div
            class="d-flex justify-center align-center"
            style="width: 40px; height: 40px; background: #E7E3FC1A; border-radius: 50%;"
          >
            <v-icon
              color="#E7E3FC"
              size="20"
            >
              {{ icons.mdiLinkVariant }}
            </v-icon>
          </div>
          <div
            class="d-flex flex-column"
            style="gap: 10px;"
          >
            <div
              class="d-flex align-center"
              style="gap: 11px;"
            >
              <span style="color: #E7E3FC; font-size: 14px;">SLT: 0{{ parentData.code }}</span>
              <div class="badge-container">
                <div
                  class="badge"
                  style="background: #9A62FD1A; color: #9A62FD; font-weight: 600; font-size: 12px;"
                >
                  <span>Pai</span>
                </div>
              </div>
            </div>
            <div
              class="d-flex align-center"
              style="gap: 20px;"
            >
              <span style="color: #7B7792; font-size: 14px;">N° Passageiros <span style="color: #E7E3FC;">{{ parentData.passengers || 0 }}</span></span>
              <span style="color: #7B7792; font-size: 14px;">Destino: <span style="color: #E7E3FC;">{{ parentData.address.local_name || '-' }}</span></span>
            </div>
          </div>
        </article>
        <InfoPainel
          :icon="icons.mdiInformationOutline"
          text="As solicitações vinculadas (filha) herdarão o motorista, o veículo e o status da solicitação pai e não poderão alterá-los."
          text-color="#FFB400"
          icon-color="#FFB400"
          border-color="#5E5132"
          background-color="#FFB4000D"
        />
        <span
          style="color: #E7E3FC; font-size: 14px; font-weight: 500;"
          class="pt-6"
        >Solicitações disponíveis:</span>
        <div
          class="mt-1 pa-5 d-flex flex-column"
          style="border: 1px solid #534D74; border-radius: 10px;"
        >
          <v-text-field
            v-model="filterData"
            label="Buscar por solicitação"
            :prepend-inner-icon="icons.mdiMagnify"
            outlined
            dense
          />
          <div
            class="d-flex flex-column"
            style="gap: 10px;"
          >
            <template v-if="loading">
              <article
                v-for="i in 3"
                :key="`skeleton-${i}`"
                class="pa-4 d-flex align-center"
                style="border: 1px solid #534D74; border-radius: 10px; gap: 14px;"
              >
                <v-skeleton-loader
                  type="avatar"
                  width="40"
                  height="40"
                />
                <div
                  class="d-flex flex-column"
                  style="gap: 10px; flex: 1;"
                >
                  <v-skeleton-loader
                    type="text"
                    width="100px"
                  />
                  <div
                    class="d-flex align-center"
                    style="gap: 20px;"
                  >
                    <v-skeleton-loader
                      type="text"
                      width="120px"
                    />
                    <v-skeleton-loader
                      type="text"
                      width="150px"
                    />
                  </div>
                </div>
              </article>
            </template>

            <span
              v-else-if="filteredSolicitations.length === 0"
              style="color: #7B7792;"
            >Nenhuma solicitação disponível para vincular.</span>

            <template v-else>
              <article
                v-for="solicitation in filteredSolicitations"
                :key="solicitation.id"
                class="pa-4 d-flex align-center"
                style="border: 1px solid #534D74; border-radius: 10px; gap: 14px;"
              >
                <v-checkbox
                  v-model="solicitation.isSolicitationSelected"
                  :value="solicitation.isSolicitationSelected"
                  @change="handleSelectSolicitation(solicitation.id)"
                ></v-checkbox>
                <div
                  class="d-flex flex-column"
                  style="gap: 10px;"
                >
                  <span style="color: #E7E3FC;">SLT: 0{{ solicitation.code }}</span>
                  <div
                    class="d-flex align-center"
                    style="gap: 20px;"
                  >
                    <span style="color: #7B7792; font-size: 14px;">N° Passageiros <span style="color: #E7E3FC;">{{ solicitation.passengers_count || 0 }}</span></span>
                    <span style="color: #7B7792; font-size: 14px;">Destino: <span style="color: #E7E3FC;">{{ solicitation.address.local_name || '-' }}</span></span>
                  </div>
                </div>
              </article>
            </template>
          </div>
        </div>
        <div class="d-flex justify-end pt-4">
          <v-btn
            color="info"
            :disabled="selectedSolicitations.length === 0 || isSending"
            @click="handleSendLinkedSolicitations"
          >
            <template v-if="!isSending">
              <v-icon>{{ icons.mdiLinkVariant }}</v-icon>
              <span>Vincular</span>
            </template>
            <v-progress-circular
              v-else
              indeterminate
              color="white"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import InfoPainel from '@/components/InfoPainel.vue'
import axiosIns from '@/plugins/axios'
import {
  mdiClose, mdiInformationOutline, mdiLinkVariant, mdiMagnify,
} from '@mdi/js'

export default {
  name: 'LinkSolicitationsModal',
  components: {
    InfoPainel,
  },
  props: {
    parentData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      icons: {
        mdiClose, mdiLinkVariant, mdiInformationOutline, mdiMagnify,
      },
      solicitations: [],
      filteredSolicitations: [],
      allSolicitations: [],
      selectedSolicitations: [],
      loading: false,
      filterData: '',
      isSending: false,
    }
  },
  watch: {
    filterData() {
      this.findFilterResult()
    },
  },
  created() {
    this.handleGetSolicitationsWithoutDriverAndVehicle()
  },
  methods: {
    handleSelectSolicitation(solicitationId) {
      const index = this.selectedSolicitations.indexOf(solicitationId)
      if (index === -1) {
        this.selectedSolicitations.push(solicitationId)
      } else {
        this.selectedSolicitations.splice(index, 1)
      }
    },
    async handleSendLinkedSolicitations() {
      try {
        this.isSending = true

        const payload = {
          parent_id: this.parentData.id,
          trip_ids: this.selectedSolicitations,
        }
        await axiosIns.patch('/api/v1/solicitations/transport_solicitation_trip/insert_parent_id_in_trips', payload)
        this.$emit('linked')
        this.closeModal()
      } catch (error) {
        console.error('Erro ao enviar solicitações vinculadas:', error)
      } finally {
        this.isSending = false
      }
    },
    closeModal() {
      this.$emit('close')
    },
    async handleGetSolicitationsWithoutDriverAndVehicle() {
      try {
        this.loading = true
        const solicitationsToLink = await axiosIns.get(`/api/v1/solicitations/transport_solicitation_trip/get_solicitations_available_to_link/${this.parentData.id}`)

        this.filteredSolicitations = solicitationsToLink.data.data
        this.allSolicitations = solicitationsToLink.data.data
      } catch (error) {
        console.error('Erro ao filtrar solicitações:', error)
        this.filteredSolicitations = []
      } finally {
        this.loading = false
      }
    },
    findFilterResult() {
      const { allSolicitations, filterData } = this
      const filterDataLower = (filterData || '').toString().trim().toLowerCase()

      if (!filterDataLower) {
        this.filteredSolicitations = this.allSolicitations

        return
      }

      this.filteredSolicitations = allSolicitations.filter(solicitation => String(`0${solicitation.code}` || '').toLowerCase().includes(filterDataLower))
    },
  },
}
</script>

<style scoped>

.parent-card {
  width: 100%;
  min-height: 74px;
  border-left: 10px solid #524E7A;
  border-radius: 10px;
  background-color: #3B355A;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  margin-top: -2px;
  text-align: left;
}

.title {
  font-weight: 600;
  font-size: 18px;
}

.close-btn {
  position: absolute;
  right: 20px;
  top: 15px;
}

.badge {
  padding: 3px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-weight: 600;
  text-align: center;
  font-size: 11px;
}
.badge-container {
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

</style>
